module.exports = __webpack_public_path__ + "img/headerModel.5d1a1222.webp";